export default __webpack_public_path__ + "static/media/skull.e5513e7c.png";